import { ExternalLink, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { PARTNER_LINK } from "@/lib/constants";

const PartnerBenefitSection = () => (
  <section id="partnerlink-info" className="py-10 md:py-20 bg-card/30">
    <div className="container">
      <div className="mx-auto max-w-3xl">
        <h2 className="font-display text-xl font-bold text-foreground sm:text-2xl md:text-3xl">
          Partnerlink &amp; Produktinfos: Was du vor dem Kauf wissen solltest
        </h2>
        <div className="mt-4 space-y-3 text-sm leading-relaxed text-muted-foreground md:text-base">
          <p>
            Alle Konditionen, Verfügbarkeiten und Produktvarianten stehen ausschließlich im offiziellen
            heilys Shop. Sie gelten dort für alle Kunden gleichermaßen und werden im Checkout automatisch
            berücksichtigt.
          </p>
          <p>
            Wir konzentrieren uns hier auf das, was vor dem Kauf wirklich hilft: Wellenlängen, Bauformen,
            Einsatzbereiche und ehrliche Erfahrungswerte aus der eigenen Anwendung.
          </p>
        </div>

        <div className="mt-6 rounded-xl border border-border bg-card p-5 sm:p-6">
          <h3 className="font-display text-base font-semibold text-foreground sm:text-lg">
            Worauf du vor der Bestellung achten kannst
          </h3>
          <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
            <li>• Einsatzbereich: punktuell (Gesicht, Gelenke) oder großflächig (Ganzkörper)</li>
            <li>• Wellenlängen: 630–660 nm sichtbares Rotlicht, 810–850 nm Nahinfrarot</li>
            <li>• Bauform und Platzbedarf: Panel, kompakte Lampe, Wearable oder Schreibtischlampe</li>
            <li>• Lieferzeit und Versandoptionen für Deutschland, Österreich und die Schweiz</li>
          </ul>
          <div className="mt-5 flex flex-col gap-3 sm:flex-row">
            <a
              href={PARTNER_LINK}
              target="_blank"
              rel="sponsored noopener noreferrer"
              onClick={() => window.lh?.trackAffiliate({ source: "partner_benefit" })}
              className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-md shadow-primary/20 transition-all hover:brightness-110"
            >
              Zum offiziellen heilys Shop
              <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
            </a>
            <Link
              to="/heilys-partnerlink"
              className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-border bg-card px-5 py-2.5 text-sm font-medium text-foreground transition-colors hover:bg-secondary"
            >
              Mehr zu Partnerlink &amp; Produktinfos
              <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default PartnerBenefitSection;
